import service from "@/store/services/me";

const state = {
  me: {}
};

const mutations = {
  SET_PROFILE: (state, profile) => {
    state.me = profile;
  },
  SET_IMAGE: (state, url) => {
    state.me.image = url;
  }
};

const actions = {
  getProfile({commit}, params) {  
    return service.getProfile(params)
      .then((response) => {
        commit("SET_PROFILE", response.profile);
      });
  },
  update({commit}, params) {  
    return service.update(params);
  },
  password({commit}, params) {  
    return service.changePassword(params);
  },
  upload({commit, dispatch}, {member, image}) {
    return service.upload(member, image)
      .then((url) => {
        commit('SET_IMAGE', url);
      });
  },
  checkAlias({commit}, params) {  
    return service.checkAlias(params)
      .then((response) => {
      });
  },
  addContact({commit}, params) {  
    return service.addContact(params)
      .then((response) => {
        return response;
      });
  },
  updateContact({commit}, params) {  
    return service.updateContact(params)
      .then((response) => {
        return response;
      });
  },
  deleteContact({commit}, params) {  
    return service.deleteContact(params)
      .then((response) => {
        return response;
      });
  },
};

const getters = {
  profile: state => state.me

};

const options = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default options;
